import { motion } from "framer-motion";
import { cardMeanings } from "../../Services/cardMeanings";
import { useLanguage } from "../../Services/Context/LanguageContext";
import "./StaticCardMeaning.css";

interface StaticCardMeaningProps {
  cardName: string;
  isReversed: boolean;
}

const StaticCardMeaning = ({
  cardName,
  isReversed,
}: StaticCardMeaningProps) => {
  const { translate } = useLanguage();
  const data = cardMeanings[cardName];
  if (!data) return null;

  const keywords = isReversed ? data.reversedKeywords : data.keywords;
  const meaning = isReversed ? data.reversedMeaning : data.meaning;

  return (
    <motion.div
      className="StaticCardMeaning"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
    >
      <div className="StaticCardMean-keywords-wrapper">
        <div className="StaticCardMeaning-keywords">
          {keywords.map((kw) => (
            <span key={kw} className="StaticCardMeaning-pill">
              {kw}
            </span>
          ))}
        </div>
      </div>

      <p className="StaticCardMeaning-meaning">{meaning}</p>

      <div className="StaticCardMeaning-symbolism-row">
        <span className="StaticCardMeaning-symbolism-label">
          {translate("symbolism")}
        </span>
        <span className="StaticCardMeaning-symbolism-text">
          {data.symbolism}
        </span>
      </div>
    </motion.div>
  );
};

export default StaticCardMeaning;
export { cardMeanings };
